import React from "react";
import { Spin, Row, Col, Radio } from "antd";
import global from "../../../common/utility/global";
import Header from "../../../components/Header";
import Filters from "../DashboardEstablecimiento/Filters";
import anioMock from '../../../common/mock/anioMock';
import mesMock from '../../../common/mock/mesMock';
import comprobanteService from "../../../service/ventas/comprobanteService";
import KpiCard from "./KpiCard";
import ChartPanel from "./ChartPanel";
import GraficoTopEstablecimientos from "./GraficoTopEstablecimientos";
import GraficoEvolucionVentas from "./GraficoEvolucionVentas";
import GraficoParticipacionEstablecimientos from "./GraficoParticipacionEstablecimientos";
import { buildDashboardData, formatCurrency, formatNumber } from "./utils";
import "./styles.css";

export default class Index extends React.Component {
    constructor(props) {
        super(props);
        // Por defecto el periodo es el mes actual (inicio = fin); con eso,
        // el grafico de Evolucion arranca mostrando dias. Si el usuario
        // amplia el rango a mas de un mes, ese mismo grafico pasa a mostrar
        // un punto por mes.
        const filter = {
            anioInicio: global.fetchCurrentYear(),
            mesInicio: global.fetchCurrentMonth(),
            anioFin: global.fetchCurrentYear(),
            mesFin: global.fetchCurrentMonth(),
            flagNotaVenta: false,
        };
        this.state = {
            loading: true,
            moneda: "PEN",
            anios: anioMock.values,
            meses: mesMock.values,
            filter,
            dashboard: buildDashboardData(null, filter),
        };
    }

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleChangeMoneda = (e) => {
        this.setState({ moneda: e.target.value });
    };

    handleClearFilters = () => {
        const filter = {
            anioInicio: global.fetchCurrentYear(),
            mesInicio: global.fetchCurrentMonth(),
            anioFin: global.fetchCurrentYear(),
            mesFin: global.fetchCurrentMonth(),
            flagNotaVenta: false,
        };
        this.setState({ filter, moneda: "PEN" });
        this.handleGenerateReport(filter);
    };

    handleGenerateReport = async (filter) => {
        this.setState({
            loading: true,
        });
        const response = await comprobanteService.dashboardEstablecimiento(filter);
        this.setState({
            dashboard: buildDashboardData(response, filter),
            loading: false,
        });
    };

    async componentDidMount() {
        await this.handleGenerateReport(this.state.filter);
    }

    render() {
        const { moneda, filter } = this.state;
        const { kpis, topEstablecimientos, evolucion, participacion } = this.state.dashboard;
        const clave = moneda === "USD" ? "usd" : "pen";
        const esMismoMes = filter.anioInicio === filter.anioFin && filter.mesInicio === filter.mesFin;
        const tituloEvolucion = `Ventas por Establecimiento (Evolución ${esMismoMes ? "diaria" : "mensual"})`;

        return (
            <div>
                <Header
                    title="Dashboard de Ventas por Establecimiento"
                    onClearFilters={this.handleClearFilters}
                    onSearch={() => this.handleGenerateReport(this.state.filter)}
                />
                <Filters filter={this.state.filter} anios={this.state.anios} meses={this.state.meses} onChange={this.handleChange} />
                <div className="moneda-toggle">
                    <Radio.Group value={moneda} onChange={this.handleChangeMoneda} buttonStyle="solid">
                        <Radio.Button value="PEN">S/ Soles</Radio.Button>
                        <Radio.Button value="USD">US$ Dólares</Radio.Button>
                    </Radio.Group>
                </div>
                <Spin tip="Cargando..." size="large" spinning={this.state.loading}>
                    <div className="kpi-row">
                        <KpiCard
                            icon="shop"
                            iconColor="#2563eb"
                            iconBackground="#dbeafe"
                            label="Total Ventas (Periodo)"
                            value={formatCurrency(kpis.totalVentas[clave].valor, moneda)}
                            tendenciaDireccion={kpis.totalVentas[clave].tendenciaDireccion}
                            tendenciaTexto={`${formatNumber(kpis.totalVentas[clave].tendenciaPct)}% vs periodo anterior`}
                        />
                        <KpiCard
                            icon="bank"
                            iconColor="#16a34a"
                            iconBackground="#dcfce7"
                            label="Establecimientos Activos"
                            value={kpis.establecimientosActivos.valor}
                            tendenciaDireccion={kpis.establecimientosActivos.tendenciaDireccion}
                            tendenciaTexto={`${kpis.establecimientosActivos.tendenciaValor} vs periodo anterior`}
                        />
                        <KpiCard
                            icon="unordered-list"
                            iconColor="#7c3aed"
                            iconBackground="#ede9fe"
                            label="Cpe Promedio"
                            value={formatCurrency(kpis.cpePromedio[clave].valor, moneda)}
                            tendenciaDireccion={kpis.cpePromedio[clave].tendenciaDireccion}
                            tendenciaTexto={`${formatNumber(kpis.cpePromedio[clave].tendenciaPct)}% vs periodo anterior`}
                        />
                        <KpiCard
                            icon="bar-chart"
                            iconColor="#ea580c"
                            iconBackground="#ffedd5"
                            label="Ventas por Establecimiento (Promedio)"
                            value={formatCurrency(kpis.ventasPromedioPorEstablecimiento[clave].valor, moneda)}
                            tendenciaDireccion={kpis.ventasPromedioPorEstablecimiento[clave].tendenciaDireccion}
                            tendenciaTexto={`${formatNumber(kpis.ventasPromedioPorEstablecimiento[clave].tendenciaPct)}% vs periodo anterior`}
                        />
                        <KpiCard
                            icon="pie-chart"
                            iconColor="#dc2626"
                            iconBackground="#fee2e2"
                            label="% Concentración Top 3"
                            value={`${formatNumber(kpis.concentracionTop3[clave].valor)}%`}
                            tendenciaDireccion={kpis.concentracionTop3[clave].tendenciaDireccion}
                            tendenciaTexto={`${formatNumber(kpis.concentracionTop3[clave].tendenciaPct)} p.p. vs periodo anterior`}
                        />
                    </div>

                    <Row gutter={16}>
                        <Col className="gutter-row" xs={24} lg={12}>
                            <ChartPanel title="Top 10 Establecimientos por Ventas">
                                <GraficoTopEstablecimientos
                                    establecimientos={topEstablecimientos.map((item) => item.nombre)}
                                    valores={topEstablecimientos.map((item) => item[clave])}
                                    moneda={moneda}
                                />
                            </ChartPanel>
                        </Col>

                        <Col className="gutter-row" xs={24} lg={12}>
                            <ChartPanel title="Ventas por Participación de Establecimientos">
                                <GraficoParticipacionEstablecimientos datos={participacion[clave]} moneda={moneda} />
                            </ChartPanel>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col className="gutter-row" span={24}>
                            <ChartPanel title={tituloEvolucion}>
                                <GraficoEvolucionVentas
                                    timeLine={evolucion.timeLine}
                                    series={evolucion[clave]}
                                    moneda={moneda}
                                />
                            </ChartPanel>
                        </Col>
                    </Row>
                </Spin>
            </div>
        );
    }
}
